import React from 'react';
import PropTypes from 'prop-types';
import CinemaSVG from 'components/CinemaSVG/CinemaSVG';


const MobileCinema = ({ title, onClick, selectedCinema, id, logo }) => (
  <div
    className={`react-cinema-filter-mobile-box${selectedCinema === id ? ' active' : ''}`}
    tabIndex={0}
    role="button"
    onClick={onClick}
  >
    <CinemaSVG cinema={logo} />
    <div className="react-cinema-filter-box-mobile-title">{title}</div>
  </div>
);

MobileCinema.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selectedCinema: PropTypes.number.isRequired,
  logo: PropTypes.string,
  id: PropTypes.number.isRequired,
};

MobileCinema.defaultProps = {
  logo: null,
};

export default MobileCinema;
